export const SET_ERROR = 'resetpassword:SET_ERROR'
export const CLEAR_MESSAGES = 'resetpassword:CLEAR_MESSAGES'